app.controller('patientVisitCardViewController', ['$rootScope', '$interval', '$controller', '$scope', '$timeout', '$state',
    '$stateParams', '$mdDialog', '$mdMenu', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'patientModel',
    'userModel', 'icdModel', 'visitModel', 'visitCardModel', 'prescriptionModel', 'referralModel', 'sickLeaveModel', '$mdToast',
    'insuranceStatementModel', 'prescribedDrugModel',
    function ($rootScope, $interval, $controller, $scope, $timeout, $state, $stateParams, $mdDialog, $mdMenu, $translate,
              objectHelper, baseModel, applicationModel, patientModel, userModel, icdModel, visitModel, visitCardModel,
              prescriptionModel, referralModel, sickLeaveModel, $mdToast, insuranceStatementModel, prescribedDrugModel) {

        angular.extend(this, $controller('baseVisitCardController', {$scope: $scope}));

        var listeners = {};

        function setData() {
            $scope.isPreview = true;

            $scope.doctorID = userModel.getCurrentContextDoctorId();

            $scope.forms = {
                activeVisitForm: null
            };

            $scope.prescribedDrugs = [];
            $scope.diagnosisList = [];

            $scope.zm = null;
        }

        function setPermissions() {
        }

        function setListeners() {
            listeners.onGetVisitCardById = function (visitCard) {
                $scope.visitCard = visitCard;
                $scope.$parent.vm.selectedTabIndex = 0;
                $scope.visitCard.visit = new VisitVO($scope.visit.id);

                $scope.prescribedDrugs = $scope.visitCard.prescribedDrugs.filter(function (drug) {
                    return !drug.deleted && !drug.prescription && !drug.recipe;
                });

                $scope.diagnosisList = $scope.visitCard.diagnosisList.filter(function (diagnosis) {
                    return !diagnosis.deleted;
                });

                $scope.medicalProcedures = $scope.visitCard.medicalProcedures.filter(function (medicalProcedure) {
                    return !medicalProcedure.deleted;
                });
            };

            listeners.onGetVisitById = function (visit) {
                $scope.visit = visit;
                $scope.$parent.visit = visit;
                $scope.showCorrectButton = ($scope.visit.doctor.id === userModel.currentUser.id);
                if ($scope.$parent.visit.visitStatus === Enum.VISIT_STATUS.CLOSED || $scope.$parent.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED) {
                    visitCardModel.getById($scope.$parent.visit.visitCard.id).then(listeners.onGetVisitCardById);
                } else {
                    $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD, {
                        patientId: $stateParams.patientId,
                        visitId: $stateParams.visitId
                    });
                }

                if ($scope.visit.id) {
                    visitModel.getZM($scope.visit.id);
                }
            };

            $scope.$on(Event.VISIT.GET_ZM.SUCCESS, function(event, data) {
                $scope.zm = data;
            });

            $scope.$on(Event.VISIT.SEND_ZM.SUCCESS, function(event, data) {
                visitModel.getZM($scope.visit.id);
            });
        }

        function setActions() {
            $scope.correct = function () {
                $state.go(Constant.STATE.APP.PATIENT.VIEW.VISIT_CARD_CORRECT, {
                    patientId: $stateParams.patientId,
                    visitId: $stateParams.visitId
                });
            };

            $scope.switchVisitTypeToICF = function () {
                $scope.visit.visitType = Enum.VISIT_TYPE.ICF;
                visitModel.update($scope.visit).then(function (savedData) {
                    $scope.visit = savedData;
                });
            };

            $scope.printPrescription = function (prescription) {
                if(prescription.p1Prescription) {
                    visitCardModel.getP1ById(prescription.id)
                        .then(function(prescriptionHTML) {
                            var newWindow = window.open();
                            newWindow.document.body.innerHTML = prescriptionHTML;
                            newWindow.focus();
                            newWindow.print();
                        });
                } else {
                    prescriptionModel.downloadPDF(prescription.id).then(function(link) {
                        visitCardModel.getById($scope.visit.visitCard.id).then(listeners.onVisitCardGetById);
                        window.open(link, '_blank');
                        window.focus();
                    });
                }
            };

            $scope.printReferral = function (referral) {
                referralModel.downloadPDF(referral.id).then(function (link) {
                    window.open(link, '_blank');
                    window.focus();
                });
            };

            $scope.printSickLeave = function () {
                sickLeaveModel.downloadPDF($scope.visitCard.sickLeave.id).then(function (link) {
                    window.open(link, '_blank');
                    window.focus();
                });
            };

            $scope.previewVisitEpicrisis = function () {
                visitCardModel.previewPDF($scope.visitCard.id);
            };

            $scope.printEpicrisis = function () {
                visitCardModel.downloadPDF($scope.visitCard.id);
            };

            $scope.printInsuranceStatement = function (insuranceStatement) {
                insuranceStatementModel.downloadPDF(insuranceStatement.id).then(function (link) {
                    window.open(link, '_blank');
                    window.focus();
                });
            };

            $scope.getFullIcfCode = function (localIcf) {
                function getCodeNumber(code) {
                    return code.substr(code.length - 1, code.length)
                }

                var fullCode = localIcf.icf.value;

                if (localIcf.firstQualifier) {
                    fullCode += localIcf.firstQualifier.value;
                }

                return fullCode;
            };

            $scope.openIcfGraph = function (data) {
                var icfData = [];

                data.every(function (element) {
                    return icfData.push(element);
                });

                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-icf-graph.html',
                    controller: 'popupIcfGraphController',
                    resolve: {
                        icfDiagnosis: function () {
                            return icfData;
                        }
                    }
                })
            };

            $scope.openStateOfHealthSimulation = function () {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-stateOfHealthSimulation.html',
                    controller: 'popupStateOfHealthSimulationController',
                    resolve: {
                        visitCardId: function () {
                            return $scope.visitCard.id;
                        },
                        icfDiagnoses: function () {
                            return $scope.visitCard.icfDiagnosis;
                        }
                    }
                });
            };

            $scope.openTreatmentCostSimulation = function () {
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/popup-treatmentCostSimulation.html',
                    controller: 'popupTreatmentCostSimulationController',
                    resolve: {
                        visitCardId: function () {
                            return $scope.visitCard.id;
                        },
                        icfList: function () {
                            return _.map($scope.visitCard.icfDiagnosis, 'icf');
                        }
                    }
                });
            };

            $scope.downloadVideoConsultation = function () {
                visitCardModel.downloadVideoConsultation($scope.visit.streamingSessionId);
            };

            $scope.openInsuranceStatement = function (insuranceType, insurance) {
                var templateConfig = {
                    templateUrl: 'edm/application/view/app/patient/popup/activeVisit/popup-insurance-statement-n9.html',
                    controller: 'popupInsuranceStatementController',
                    resolve: {
                        visit: function () {
                            return $scope.visit;
                        },
                        diagnosisList: function () {
                            return angular.copy($scope.visitCard.diagnosisList);
                        },
                        patient: function () {
                            return $scope.patient;
                        },
                        insuranceStatementType: function () {
                            return insuranceType
                        },
                        insurance: function () {
                            return insurance;
                        },
                        previewOnly: function () {
                            return ($scope.visit.visitStatus === Enum.VISIT_STATUS.COMPLETED);
                        }
                    }
                };
                if (insuranceType === Enum.INSURANCE_STATEMENT_TYPE.N14) {
                    templateConfig.templateUrl = 'edm/application/view/app/patient/popup/activeVisit/popup-insurance-statement-n14.html';
                }
                $mdDialog.show(templateConfig)
            };


            $scope.removeOTCDrugs = function (p) {
                var label = p.drug.name;
                $mdDialog.show({
                    templateUrl: 'edm/application/view/app/patient/popup/stateOfHealth/popup-delete-confirmation.html',
                    controller: 'popupDeleteConfirmationController',
                    resolve: {
                        title: function () {
                            return null;
                        },
                        message: function () {
                            return 'T.MODULE.PATIENT.TAKEN_DRUG_DELETE_CONFIRMATION';
                        },
                        labels: function () {
                            return [label];
                        },
                        yesText: function () {
                            return 'T.UI.APPLICATION.DELETE';
                        },
                        noText: function () {
                            return 'T.UI.APPLICATION.CANCEL';
                        },
                        item: function () {
                            return p;
                        }
                    }
                }).then(function (data) {
                    prescribedDrugModel.delete(data).then(function () {
                        visitModel.getById($stateParams.visitId).then(listeners.onGetVisitById);
                    })
                })
            }

            $scope.sendZM = function() {
                visitModel.sendZM($scope.visit.id);
            };
        }

        function configureInterface() {

        }

        function initialize() {
            visitModel.getById($stateParams.visitId).then(listeners.onGetVisitById);

            $scope.$parent.$parent.visitCardMode = 'view';

            $timeout(function () {
                $scope.$parent.vm.selectedTabIndex = 0;
            }, 300)
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
